<template>
    <div class="page">
        <div class="cerd">
            <div class="cerd-title">刷新复机配置</div>
            <el-row>
                <el-col :span="7">
                    <label style="width:120px;">用户是否可用：</label>
                    <el-select v-model="isUserOpen" placeholder="请选择">
                        <el-option label="是" value="1"></el-option>
                        <el-option label="否" value="0"></el-option>
                   </el-select>
                </el-col>
                 <el-col :span="7">
                    <label style="width:120px;">管理员是否可用：</label>
                    <el-select v-model="isAdminOpen" placeholder="请选择">
                        <el-option label="是" value="1"></el-option>
                        <el-option label="否" value="0"></el-option>
                   </el-select>
                </el-col>
                 <el-col :span="6">
                    <label >距离月底几天不可用(未充值次月)：</label>
                    <el-input-number v-model="day" :min="1" :max="365" label="请输入"></el-input-number>
                </el-col>
                 <el-col :span="1">
                     <el-button type="primary"  @click="secondBackDiagnoseHandler" plain icon="el-icon-refresh">更新</el-button>
                </el-col>
            </el-row> 
        </div>
        <div class="cerd">
            <div class="cerd-title">换卡邮费设置</div>
            <el-row >
                <el-col :span="5">
                    <label>是否开启邮费：</label>
                    <el-radio-group v-model="postageForm.is_enable">
                        <el-radio label="1">开启</el-radio>
                        <el-radio label="0">停用</el-radio>
                    </el-radio-group>
                </el-col> 
                <el-col :span="5">
                    <label>是否充值自动退款：</label>
                    <el-radio-group v-model="postageForm.is_auto_back">
                        <el-radio label="1">开启</el-radio>
                        <el-radio label="0">停用</el-radio>
                    </el-radio-group>
                </el-col> 

                <el-col :span="5">
                    <label>邮费(元)：</label>
                    <el-input-number v-model="postageForm.priceRmb" :min="0"  ></el-input-number>
                </el-col>

                <el-col :span="1">
                    <el-button type="primary"  @click="updatePostageConfig()" plain icon="el-icon-refresh">更新</el-button>
                </el-col>

            </el-row>
        </div>


        <div class="cerd">
            <div class="cerd-title">支付通道配置</div>
            <el-row >
                <el-col :span="3" v-for=" item in payChanle" :key="item.id">
                    <label >{{item.alias}}: </label>&nbsp;
                    <el-switch v-model="item.enable"></el-switch>
                </el-col>

                <el-col :span="1">
                    <el-button type="primary"  @click="updatePayChannel()" plain icon="el-icon-refresh">更新</el-button>
                </el-col>
            </el-row>
        </div>

        <div class="cerd">
            <div class="cerd-title">是否开启组合支付</div>
            <el-row >
                <el-col :span="12">
                    <label >组合支付: </label>
                    <el-switch v-model="zhizuPay"></el-switch>
                    <span style="color:red" >  开启后，可使用余额+微信支付组合购买套餐</span>
                </el-col>

                <el-col :span="1">
                    <el-button type="primary"  @click="updateZhizhuData()" plain icon="el-icon-refresh">更新</el-button>
                </el-col>
            </el-row>
        </div>

        <div class="cerd">
            <div class="cerd-title">公众号配置</div>
            <el-row >
                <el-col :span="6">
                    <label >公众号APPID：</label>
                    <span>{{collectionConfigShowData.wxAppId}}</span>
                </el-col>
                <el-col :span="6">
                    <label style="">公众号密钥：</label>
                    <span>{{collectionConfigShowData.wxAppSecret}}</span>
                </el-col>

                <el-col :span="1">
                    <el-button type="primary"  @click="updateCollectionConfig()" plain icon="el-icon-edit">编 辑</el-button>
                </el-col>
            </el-row>
        </div>

        <div class="cerd">
            <div class="cerd-title">赠送金微信商户配置 <span style="color:red;padding-left:10px;font-size:14px;font-weight: 100;">(不配置，则默认主收款商户。)</span></div>
            <el-row >
                <el-col :span="7">
                    <label style="width:120px;">微信商户号：</label>
                    <el-input style="width:180px;" v-model="id" placeholder="请输入"></el-input>
                </el-col>

                 <el-col :span="7">
                    <label style="width:120px;">微信商户密钥：</label>
                    <el-input style="width:220px;" v-model="name" placeholder="请输入"></el-input> 
                </el-col>
                <el-col :span="1">
                    <el-button type="primary"  @click="updatePriceData()" plain icon="el-icon-refresh">更新</el-button>
                </el-col>
            </el-row>
        </div>

        <div class="cerd">
            <div class="cerd-title">赠送金汇付商户配置 <span style="color:red;padding-left:10px;font-size:14px;font-weight: 100;">(不配置，则默认主收款商户。)</span></div>
            <el-row >
                <el-col :span="7">
                    <label style="width:120px;">商户编号：</label>
                    <el-input style="width:180px;" v-model="subId" placeholder="请输入app_开头信息"></el-input>
                </el-col>

                 <el-col :span="7">
                    <label style="width:120px;">密钥信息：</label>
                    <el-input style="width:220px;" v-model="subKey" placeholder="请输入api_live开头信息"></el-input> 
                </el-col>
                <el-col :span="1">
                    <el-button type="primary"  @click="updatePriceDataCft()" plain icon="el-icon-refresh">更新</el-button>
                </el-col>
            </el-row>
        </div>

        <div class="cerd">
            <div class="cerd-title">禁止充值</div>
            <el-row >
                <el-col :span="8">
                    <label>运营商：</label>
                    <el-select v-model="rechargePermissions.supplierIds" multiple  filterable  clearable
                    placeholder="请选择" style="width: 80%;">
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name + '(' + item.alias + ')'"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="1">
                    <el-button type="primary"  @click="updateRechargePermissions()" plain icon="el-icon-refresh">更新</el-button>
                </el-col>
            </el-row>
        </div>

        <div class="cerd">
            <div class="cerd-title">余额充值限制</div>
            <el-row >
                <el-col :span="8">
                    <label>运营商：</label>
                    <el-select v-model="balanceRechargeLimit.id"  multiple filterable  clearable
                    placeholder="请选择" style="width: 80%;">
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name + '(' + item.alias + ')'"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="1">
                    <el-button type="primary"  @click="updateBalanceRecharge()" plain icon="el-icon-refresh">更新</el-button>
                </el-col>
            </el-row>
        </div>

        <div class="cerd">
            <div class="cerd-title">代理商申请退款设置</div>
            <el-row >
                <el-col :span="5">
                    <label>是否允许代理商退款：</label>
                    <el-radio-group v-model="agentState">
                        <el-radio label="1">开启</el-radio>
                        <el-radio label="0">停用</el-radio>
                    </el-radio-group>
                </el-col> 
   
                <el-col :span="1">
                    <el-button type="primary"  @click="updateAgentState()" plain icon="el-icon-refresh">更新</el-button>
                </el-col>
            </el-row>
        </div>

        <div class="cerd">
            <div class="cerd-title">提现配置</div>
            <el-row >
                <el-col :span="7">
                    <label style="width:120px;">最小提现金额：</label>
                    <el-input style="width:120px;" v-model="cashoutMinAmount" placeholder="请输入"></el-input> 元
                </el-col>

                 <el-col :span="7">
                    <label style="width:120px;">单笔手续费率：</label>
                    <el-input style="width:120px;" v-model="cashoutFee" placeholder="请输入"></el-input> /百分比
                </el-col>
                  <el-col :span="7">
                    <label style="width:120px;">提现间隔天数：</label>
                    <el-input style="width:120px;" v-model="cashoutData" placeholder="请输入"></el-input> 天
                </el-col>

   
                <el-col :span="1">
                    <el-button type="primary"  @click="saveWithdrawConfigHandle()" plain icon="el-icon-refresh">更新</el-button>
                </el-col>
            </el-row>
        </div>

        <div class="cerd">
            <div class="cerd-title">购卡配置</div>
            <el-row >
                <el-col :span="7">
                    <label style="width:120px;">购卡金额：</label>
                    <el-input style="width:120px;" v-model="buyCardCost" placeholder="请输入"></el-input> 元
                </el-col>

                <el-col :span="7">
                    <label style="width:120px;">是否允许购卡：</label>
                    <el-select v-model="isNable" placeholder="请选择" clearable>
                        <el-option value="1" label="允许"></el-option>
                        <el-option value="0" label="不允许"></el-option>
                    </el-select>
                </el-col>

   
                <el-col :span="1">
                    <el-button type="primary"  @click="updateBuyCardCost()" plain icon="el-icon-refresh">更新</el-button>
                </el-col>
            </el-row>
        </div>

        <div class="cerd">
            <div class="cerd-title">预充值配置</div>
            <el-row >
                <el-col :span="7">
                    <label style="width:120px;">手续费：</label>
                    <el-input style="width:120px;" v-model="invent" placeholder="请输入"></el-input> /百分比
                </el-col>
                <el-col :span="1">
                    <el-button type="primary"  @click="updateBuyCardCost1()" plain icon="el-icon-refresh">更新</el-button>
                </el-col>
            </el-row>
        </div>

        <el-dialog :append-to-body="true"  title="公众号配置" :visible.sync="collectionConfigVisible" width="600px" :close-on-click-modal="false">
            <el-form :model="collectionConfigFormdata" :rules="collectionConfigRules" ref="collectionConfigForm" label-width="120px" class="demo-ruleForm">
                <el-form-item label="公众号APPID：" prop="wxAppId">
                    <el-input v-model="collectionConfigFormdata.wxAppId"></el-input>
                </el-form-item>
                <el-form-item label="公众号密钥：" prop="wxAppSecret">
                    <el-input v-model="collectionConfigFormdata.wxAppSecret"></el-input>
                </el-form-item>
                <el-form-item label="公众号证书：" >
                    <div class="toChooseFileBtn"></div>
                    <input multiple type="file" ref="file" id="secondBack-uploadFile" class="uploadFile" @change="chooseFile($event)">
                    <p>
                        <span v-show="collectPkcsFileName==''" style="color: #F56C6C;">未选择文件</span>
                        <span v-show="collectPkcsFileName!=''">已选择文件 {{collectPkcsFileName}}</span>
                    </p>
                </el-form-item> 
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelToSetCollectionConfig()">取 消</el-button>
                <el-button type="primary" @click="collectionConfigHandle()">保 存</el-button>
            </span>            
        </el-dialog>
    </div>
</template>
<script>
import {getSecondBackInfo, updateSecondBackState, getBindPhoneInfo, updateBindPhoneState, secondBackDiagnose, querySecondBack,querySysConfigCoupon,updateSysConfigCoupon,queryCouponList, selectAdminCollectionConfig, adminCollectionConfig} from '@/api/customers.js'
import common from '@/utils/common.js'
import {saveAgentWithdrawConfig, getAgentWithdrawConfig} from '@/api/system.js'
export default {
    data(){
        return {
             appid:'',
            aliPriKey:'',
            aliPubKey:'',


            subId:'',
            subKey:'',
            mchPwdKey:'',

            zhizuPay:'',
            id:'',
            name:'',

            merchantId:'',
            tradeKey:'',
            notifyKey:'',

            agentState:'',
            secondBackState: '',
            dayOfBack:100,
            maxMoney:5,
            bindState: 1,
            isUserOpen: '',
            isAdminOpen: '',
            day: 1,
            coupon:{
                "is_enable":0,
                "id":null,
                "title":''
            }, 
            couponList:[],
            loading: false,


            //收款配置
            collectionConfigShowData: {
                wxAppId: null,
                wxMchId: null,
                wxKeySign: null,
                wxAppSecret: null,
                collectPkcsUrl: null,
            },
            collectPkcsFileName:'',
            collectionConfigVisible: false,
            collectionConfigFormdata:{
                wxAppId: null,
                wxMchId: null,
                wxKeySign: null,
                wxAppSecret: null,
                p12: null,
                collectPkcsUrl: null,
            },
            collectionConfigRules: {
                wxAppId: [
                    { required: true, message: '请输入wxAppId', trigger: 'blur' },
                ],
                wxMchId: [
                    { required: true, message: '请输入wxMchId', trigger: 'blur' },
                ],
                wxKeySign: [
                    { required: true, message: '请输入wxKeySign', trigger: 'blur' },
                ],
                wxAppSecret: [
                    { required: true, message: '请输入wxAppSecret', trigger: 'blur' },
                ],
            },

            //支付通道配置
            payChanle:[],

            //邮费配置
            postageForm:{
                is_enable: null,
                priceRmb: null,
                is_auto_back: null,
            },

            areaOption: [
                {name:'北京',key:11},
                {name:'天津',key:12 },
                {name:'河北',key:13 },
                {name:'山西',key:14 },
                {name:'内蒙古',key:15},
                {name:'辽宁',key:21},
                {name:'吉林',key:22},
                {name:'黑龙江',key:23},
                {name:'上海',key:31 },
                {name:'江苏',key:32 },
                {name:'浙江',key:33},
                {name:'安徽',key:34 },
                {name:'福建',key:35 },
                {name:'江西',key:36 },
                {name:'山东',key:37},
                {name:'河南',key:41 },
                {name:'湖北',key:42 },
                {name:'湖南',key:43},
                {name:'广东',key:44 },
                {name:'广西',key:45 },
                {name:'海南',key:46},
                {name:'重庆',key:50},
                {name:'四川',key:51},
                {name:'贵州',key:52},
                {name:'云南',key:53},
                {name:'西藏',key:54},
                {name:'陕西',key:61},
                {name:'甘肃',key:62},
                {name:'青海',key:63},
                {name:'宁夏',key:64},
                {name:'新疆',key:65},
                {name:'台湾',key:71},
                {name:'香港',key:81},
                {name:'澳门',key:82},
            ],//字典

            authenticationCinfig:{
                is_enable: 0,
                limit_area: null,
            },

            flowLimitConfig:{
                suppliers:null,
                datas:null,
                states:'0'
            },

            intoNoLimitConfig:{
                cofValue: null,
            },

            branchSupplierOption: [],//运营商字典
            rechargePermissions:{
                supplierIds:[],
            },

            cashoutMinAmount:'',
            cashoutFee:'',
            cashoutData:'',
            buyCardCost:null,
            isNable:'',
            invent:'',
            simConfig:{
                type: null,
            },
            simTypeOptions:[{id: '0', name:'秒嘀'}, {id: '1', name:'雁云'}],

            balanceRechargeLimit: {
                id: []
            }


        }
    },
    methods: {

        getFlowLimits(){
            common.sysRequest("pkg/group/sim/data/select/zhifubao", null, 'get').then(res=>{
                if(res.data.code == 200){
                    this.appid = res.data.data.appid;
                    this.aliPriKey=res.data.data.aliPriKey;
                    this.aliPubKey=res.data.data.aliPubKey;
                }else{
                    this.$message.error(res.data.message)
                }     
            }).catch(err=> console.error(err));
        },
        updateFlowLimits(){
            let formData = new FormData();
            Object.keys(this.flowLimitConfig).forEach((key) => {
                formData.append(key, this.flowLimitConfig[key]);
            });

            formData.set("appid", this.appid);
            formData.set("aliPriKey", this.aliPriKey);
            formData.set("aliPubKey", this.aliPubKey);

            common.sysRequest("pkg/group/sim/data/update/zhifubao",formData, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                    this.getFlowLimits();
                }     
            }).catch(err=> console.error(err));
        },


         //查看
        sectPriceDataCft(){
            common.sysRequest('pkg/group/select/prceiData/cft', {}, 'post').then(res => {
                if(res.data.code == 200){
                    let result =res.data.data;
                    this.subId = result.subId;
                    this.subKey = result.subKey;
                    this.mchPwdKey = result.mchPwdKey;
                }else {
                        this.$message.error(res.data.message)
                    }
            })
        },
         updatePriceDataCft(){
            var data={
                subId:this.subId,
                subKey:this.subKey,
                mchPwdKey:this.mchPwdKey
            }
            common.sysRequest('pkg/group/update/prceiData/cft', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.sectPriceData();
                     this.$message.success(res.data.message)
                }else {
                    this.$message.error(res.data.message)
                }
            })
        },
        //收款配置
        saveWithdrawConfigHandle(){
            if(this.cashoutMinAmount == null || this.cashoutMinAmount == ''){
                this.$message.error('请输入最小提现金额');    
                return ;
            }
            if(this.cashoutFee == null || this.cashoutFee == ''){
                this.$message.error('请输入单笔手续费');    
                return ;
            }
              if(this.cashoutData == null || this.cashoutData == ''){
                this.$message.error('请输入提现间隔天数');    
                return ;
            }
            let d = {
                cashoutMinAmount: Number(this.cashoutMinAmount),
                cashoutFee: Number(this.cashoutFee),
                cashoutData:Number(this.cashoutData)
            }

            this.$confirm("确定保存此配置吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                saveAgentWithdrawConfig(d).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message)
                        this.getWithdrawConfigHandle();               
                    }else{
                        this.$message.error(res.data.message)
                    }
                })
            }).catch(() => {
                
            });
        },

        getWithdrawConfigHandle(){
            getAgentWithdrawConfig({}).then(res => {
                if(res.data.code == 200){
                    if(res.data.data.cashoutMinAmount){
                        this.cashoutMinAmount = res.data.data.cashoutMinAmount;
                    }
                    
                    if(res.data.data.cashoutFee){
                        this.cashoutFee = res.data.data.cashoutFee;
                    }
                     if(res.data.data.cashoutData){
                        this.cashoutData = res.data.data.cashoutData;
                    }
                }
            })
        },


         //查看
        sectZhizhuData(){
            common.sysRequest('sysConfig/zizhu/get', {}, 'post').then(res => {
                if(res.data.code == 200){
                    this.zhizuPay =res.data.data;
                }else {
                        this.$message.error(res.data.message)
                    }
            })
        },
         updateZhizhuData(){
            var data={
                autoPay:this.zhizuPay
            }
            common.sysRequest('sysConfig/zizhu/set', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.sectZhizhuData();
                     this.$message.success(res.data.message)
                }else {
                    this.$message.error(res.data.message)
                }
            })
        },




         //查看
        sectPriceData(){
            common.sysRequest('pkg/group/select/prceiData', {}, 'post').then(res => {
                if(res.data.code == 200){
                    let result =res.data.data;
                    this.id = result.subId;
                    this.name = result.subKey;
                }else {
                        this.$message.error(res.data.message)
                    }
            })
        },
         updatePriceData(){
            var data={
                id:this.id,
                name:this.name
            }
            common.sysRequest('pkg/group/update/prceiData', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.sectPriceData();
                     this.$message.success(res.data.message)
                }else {
                    this.$message.error(res.data.message)
                }
            })
        },

        updateSecondBackStateHandler(){
            let self = this;
            let req= {is_enable:self.secondBackState,day_of_back:self.dayOfBack,max_money:self.maxMoney};
            let data = {
                cofValue: JSON.stringify(req)
            };
            updateSecondBackState(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success('设置成功')
                }else{
                    this.$message.error(res.data.message)
                }
            })
        },
        updateBindPhoneStateHandler(){
            var data = {
                bindState: this.bindState
            }
            updateBindPhoneState(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message)
                }else{
                    this.$message.error(res.data.message)
                }
            })
        },
        updateCouponInfoHandler(){
            let self = this;
            let param = {};
            param.coupon_id = self.coupon.id;
            param.id = self.coupon.id;
            param.is_enable = self.coupon.is_enable;
            param.title = self.coupon.title;
            let data = {
                cofValue: JSON.stringify(param)
            };

            updateSysConfigCoupon(data).then(res=>{
                if(res.data.code == 200){
                    this.$message.success('设置成功')
                }else{
                    this.$message.error(res.data.message)
                }
            });
        },
        secondBackDiagnoseHandler(){
            const params = {
                isUserOpen: Number(this.isUserOpen),
                isAdminOpen: Number(this.isAdminOpen),
                day: this.day
            }
            //js对象转format-data
            const data = new FormData();
            Object.keys(params).forEach((key) => {
                data.append(key, params[key]);
            });
            secondBackDiagnose(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message)
                }else{
                    this.$message.error(res.data.message)
                }
            })
        },
        updateAgentState(){
                var data={
                    state:this.agentState
                }
              common.sysRequest("agent/apply/state/update", data, 'post').then(res=>{
                if(res.data.code == 200){
                     this.$message.success(res.data.message);
                        common.sysRequest("/agent/apply/state", {}, 'post').then(res=>{
            if(res.data.code == 200){
                this.agentState=res.data.data;
            }else{
                this.$message.error(res.data.message)
            }     
        }).catch(err=> console.error(err));
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },
        getPostageConfig(){
            common.sysRequest("sysConfig/postageOrder/query", null, 'post').then(res=>{
                if(res.data.code == 200){
                    for(let key in this.postageForm){
                        this.postageForm[key] = res.data.data[key];
                    }
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },

        updatePostageConfig(){
            let fd = new FormData();
            Object.keys(this.postageForm).forEach((key) => {
                fd.append(key, this.postageForm[key]);
            });
            common.sysRequest("sysConfig/postageOrder", fd, 'post').then(res=>{
                if(res.data.code == 200){
                    this.getPostageConfig();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },
        querySecondBackDiagnose(){
            querySecondBack(null).then(res => {
                if(res.data.code == 200){
                    this.isUserOpen = res.data.data.isUserOpen;
                    this.isAdminOpen = res.data.data.isAdminOpen;
                    this.day = res.data.data.day;
                }else{
                    this.$message.error(res.data.message)
                }
            })
        },
        remoteMethod(query){
            let self = this;
            if (query && query.length > 0) {
                self.loading = true;
                setTimeout(() => {
                    queryCouponList({"titleLike":query}).then(res=>{
                        if(res.data.code == 200){
                            self.loading = false;
                            self.couponList = res.data.data;
                        }
                      
                       
                    }).catch(err=>console.error(err));
                    
                }, 200);
                
            }
        },

        //收款配置
        collectionConfigHandle(){
            this.$refs["collectionConfigForm"].validate((valid) => {
                if (valid) {
                    this.$confirm("确定保存新修改的数据吗？", "提示" ,{          
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        let formdata = new FormData();
                        Object.keys(this.collectionConfigFormdata).forEach((key) => {
                            formdata.append(key, this.collectionConfigFormdata[key]);
                        });

                        adminCollectionConfig(formdata).then(res => {
                            if(res.data.code == 200){
                                this.$message.success(res.data.message)
                                this.cancelToSetCollectionConfig(); 
                                //查询总部微信收款配置
                                this.getAdminCollectionConfig();                  
                            }else{
                                this.$message.error(res.data.message)
                            }
                        })
                    }).catch(() => {
                        
                    });
                }
            });

        },
        //取消收款配置
        cancelToSetCollectionConfig(){
            for(let key in this.collectionConfigFormdata){
                this.collectionConfigFormdata[key] = null;
            }
           // document.getElementById('secondBack-uploadFile').value = '';
            this.collectPkcsFileName = '';
            this.collectionConfigVisible = false;
        },
        //选择证书文件
        chooseFile(event) {
            let files = event.target.files;
            let filename = files[0].name          //只有一个文件
            if ( filename.lastIndexOf('.') <= 0 ) {
                return alert("Please add a valid image!")        //判断文件是否有效
            }
            let fileReader = new FileReader()                //内置方法new FileReader()   读取文件
            fileReader.readAsDataURL(files[0])
            this.collectionConfigFormdata.p12 = files[0];
            this.collectPkcsFileName = filename;
        },

        //新增收款配置
        addCollectionConfig(){
            for(let key in this.collectionConfigFormdata){
                this.collectionConfigFormdata[key] = null;
            }
            this.collectionConfigVisible = true;
        },

        //修改收款配置
        updateCollectionConfig(){
            //查询总部微信收款配置
            this.getAdminCollectionConfig();
            this.collectionConfigVisible = true;
        },

        getAdminCollectionConfig(){
            selectAdminCollectionConfig(new FormData()).then(res => {
                if(res.data.code == 200){
                    if(res.data.data){
                        for(let key in res.data.data){
                            this.collectionConfigShowData[key] = res.data.data[key];
                            this.collectionConfigFormdata[key] = res.data.data[key];
                        }
                        this.collectionConfigFormdata.collectPkcsUrl = res.data.data.collectPkcsUrl;
                        this.collectionConfigShowData.collectPkcsUrl = process.env.VUE_APP_IMG_URL + '/' +res.data.data.collectPkcsUrl;
                    }
                }else{
                    this.$message.error(res.data.message)
                }
            })
        },

        //更新总部支付通道
        updatePayChannel(){
            let json = {cofValue:JSON.stringify(this.payChanle)}
            common.sysRequest("/sysConfig/pay/channel", json, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message)
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },


        //查询实名认证配置
        getAuthentication(){
            common.sysRequest("sysConfig/auth/state/select", null, 'get').then(res=>{
                if(res.data.code == 200){
                    let d = JSON.parse(res.data.data.cofValue);
                    this.authenticationCinfig.is_enable = Number(d.is_enable) ;
                    this.authenticationCinfig.limit_area = d.limit_area.split(',').map(Number);
                }else{
                    this.$message.error(res.data.message)
                }     
            }).catch(err=> console.error(err));
        },

        //更改实名认证配置
        updateAuthentication(){
            let data = {
                is_enable: this.authenticationCinfig.is_enable,
                limit_area: this.authenticationCinfig.limit_area.join(",")
            }
            let formData = new FormData();
            Object.keys(data).forEach((key) => {
                formData.append(key, data[key]);
            });
            common.sysRequest("sysConfig/auth/state/update", formData, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                    this.getAuthentication();
                }     
            }).catch(err=> console.error(err));
        },
        

        //查询流量限额配置
        getFlowLimit(){
            common.sysRequest("pkg/group/sim/data/select", null, 'get').then(res=>{
                if(res.data.code == 200){
                  this.merchantId=res.data.data.merchantId;
                  this.tradeKey=res.data.data.tradeKey;
                  this.notifyKey=res.data.data.notifyKey;
                }else{
                    this.$message.error(res.data.message)
                }     
            }).catch(err=> console.error(err));
        },

        //更改流量限额配置
        updateFlowLimit(){
            let formData = new FormData();
            Object.keys(this.flowLimitConfig).forEach((key) => {
                formData.append(key, this.flowLimitConfig[key]);
            });

            formData.set("merchantId", this.merchantId);
            formData.set("tradeKey", this.tradeKey);
            formData.set("notifyKey", this.notifyKey);
            common.sysRequest("pkg/group/sim/data/update",formData, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                    this.getFlowLimit();
                }     
            }).catch(err=> console.error(err));
        },


        //查询接入号限制登录配置
        getIntoNoLimit(){
            common.sysRequest("sysConfig/sim/intono/select", null, 'get').then(res=>{
                if(res.data.code == 200){
                    this.intoNoLimitConfig = res.data.data;
                }else{
                    this.$message.error(res.data.message)
                }     
            }).catch(err=> console.error(err));
        },

        //更改接入号限制登录配置
        updateIntoNoLimit(){
            let cofValue = this.intoNoLimitConfig.cofValue;
            common.sysRequest("sysConfig/sim/intono/update", {cofValue: cofValue.replace(/，/g, ",")}, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                    this.getIntoNoLimit();
                    
                }     
            }).catch(err=> console.error(err));
        },

        

        //查询充值权限
        getRechargePermissions(){
            common.sysRequest("sysConfig/sim/invent/select", null, 'get').then(res=>{
                if(res.data.code == 200){
                    this.rechargePermissions.supplierIds = res.data.data.cofValue.split(",");
                }else{
                    this.$message.error(res.data.message)
                }     
            }).catch(err=> console.error(err));
        },

        //取消充值权限
        updateRechargePermissions(){
            let formData = new FormData();
            formData.append("supplierIds", this.rechargePermissions.supplierIds.join(","))
            common.sysRequest("sysConfig/sim/invent/update", formData, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                    this.getRechargePermissions();
                }     
            }).catch(err=> console.error(err));
        },


        

        //查询短信配置
        getSimConfig(){
            common.sysRequest("sysConfig/sms/select", null, 'get').then(res=>{
                if(res.data.code == 200){
                    this.simConfig.type = res.data.data.cofValue;
                }else{
                    this.$message.error(res.data.message)
                }     
            }).catch(err=> console.error(err));
        },

        //修改短信配置
        updateSimConfig(){
            let formData = new FormData();
            formData.append("type", this.simConfig.type)
            common.sysRequest("sysConfig/sms/update", formData, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                    this.getSimConfig();
                }     
            }).catch(err=> console.error(err));
        },

        //查询余额充值限制
        getBalanceRecharge(){
            common.sysRequest("/sysConfig/user/account", null, 'get').then(res => {
                if(res.data.code == 200){
                    this.balanceRechargeLimit.id = res.data.data.cofValue.split(",");
                }else{
                    this.$message.error(res.data.message)
                } 
            })
        },

        //更新余额充值限制
        updateBalanceRecharge(){
            let formData = new FormData();
            formData.append("id", this.balanceRechargeLimit.id.join(","))
            common.sysRequest("sysConfig/update/account", formData, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                    this.getBalanceRecharge();
                }     
            }).catch(err=> console.error(err));
        },
        //查看购卡金额
        lookBuyCardCost(){
            common.sysRequest('bindPhone/buy/sim/price', {}, 'post').then(res => {
                if(res.data.code == 200){
                    let result =res.data.data;
                    this.buyCardCost = result.agent_price/100;
                    this.isNable = result.isNable;
                    this.invent=result.invent;
                }
            })
        },
        //更新购卡金额
        updateBuyCardCost(){
            this.$confirm("确定要保存吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                let data = {
                    price: this.buyCardCost * 100,
                    isNable: this.isNable
                }
                common.sysRequest('bindPhone/update/sim/price', data, 'post').then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message)
                        this.lookBuyCardCost();
                    }else {
                        this.$message.error(res.data.message)
                    }
                })
            }).catch(() => {
                
            });
        },
        //更新购卡金额
        updateBuyCardCost1(){
            this.$confirm("确定要保存吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                let data = {
                    id: this.invent,
                    isNable: this.isNable
                }
                common.sysRequest('bindPhone/update/invent/price', data, 'post').then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message)
                        this.lookBuyCardCost();
                    }else {
                        this.$message.error(res.data.message)
                    }
                })
            }).catch(() => {
                
            });
        },

    },
    created(){
        this.getFlowLimits();
        this.sectPriceDataCft();
        this.sectZhizhuData();
        this.sectPriceData();
        this.lookBuyCardCost()
        this.getWithdrawConfigHandle()
        getSecondBackInfo({}).then(res => {
            if(res.data.code == 200){
                let record = JSON.parse(res.data.data.cofValue);
                if(record){
                    this.secondBackState = record.is_enable ? record.is_enable+'' : '0';
                    this.dayOfBack = record.day_of_back ? record.day_of_back:0;
                    this.maxMoney = record.maxMoney ? record.maxMoney : 5;
                }
            }else{
                this.$message.error(res.data.message)
            }            
        });

        getBindPhoneInfo({}).then(res => {
            if(res.data.code == 200){
                this.bindState = res.data.data.bind_state;
            }else{
                this.$message.error(res.data.message);
            }
        });
        
        
        querySysConfigCoupon({}).then(res=>{
            if(res.data.code == 200){
                let record = JSON.parse(res.data.data.cofValue);
                if(record){
                    this.couponList.push(record);
                    this.coupon = record;
                }
            }else{
                this.$message.error(res.data.message)
            }     
            
        }).catch(err=> console.error(err));

        this.querySecondBackDiagnose();

        //邮费配置
        this.getPostageConfig();

        //查询总部微信收款配置
        this.getAdminCollectionConfig();

        this.getAuthentication();
        this.getIntoNoLimit();
        this.getFlowLimit();
        this.getRechargePermissions();
        this.getSimConfig();
        this.getBalanceRecharge();

        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
        

        //查询总部支付通道
        common.sysRequest("/sysConfig/pay/channel/select", null, 'post').then(res=>{
            if(res.data.code == 200){
                this.payChanle = JSON.parse(res.data.data.cofValue);
            }else{
                this.$message.error(res.data.message)
            }     
        }).catch(err=> console.error(err));
        //查询总部支付通道
        common.sysRequest("/agent/apply/state", {}, 'post').then(res=>{
            if(res.data.code == 200){
                this.agentState=res.data.data;
            }else{
                this.$message.error(res.data.message)
            }     
        }).catch(err=> console.error(err));



    }
}
</script>
<style lang="less" scoped>
.cerd{
    background:#fff;
    border-radius: 8px;
    padding:16px;
    margin-bottom:20px;
    .cerd-title{
        font-size: 16px;
        font-weight:bold;
        color:#242225;
        margin-bottom:12px;
    }
}
.el-row {
    display: flex;
    align-items: center;
}
</style>